import React from 'react';
import Modal from '../Common/Modal';
import './index.scss';

interface IProps {
    url: string; // iframe url
    rest: any;
}

const IframeModal = (props: IProps): React.ReactElement => {
    const { url, ...rest } = props;

    return (
        <Modal {...rest}>
            <iframe className="modal-iframe" src={url}/>
        </Modal>
    )
}

export default IframeModal;